export default __webpack_public_path__ + "static/reason-chart-9d58587e0e4cd69b54d4c3aae10ca3ec.png";